// extracted by mini-css-extract-plugin
module.exports = {"footer-container":"footer__footer-container___Hlwus","openvoice-legal-text":"footer__openvoice-legal-text___3TYGo","links-copyright":"footer__links-copyright___Lx33U"};